import type {
	FieldOptions as FieldOptionsOnServer,
	OptionType as FieldOptionOnServer,
} from '@atlassian/jira-common-rest/src/internal/simplified/1.0/projects/id/issuetypes/id/types.tsx';
import type {
	AssociatedField,
	FieldConfiguration,
	FieldOptions,
	OptionType as FieldOption,
} from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/types/layout-items.tsx';
import type { FieldRequestData } from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/types/save-changes.tsx';
import { JSD_FIELD_ALIAS, JSD_FIELD_HELPTEXT } from '../../../../common/constants.tsx';

const removeEmptyOptions = (option: FieldOptionOnServer) =>
	option && typeof option.value === 'string' && option.value !== '';

const normalizeInactiveFieldLozenge = ({
	inactiveFieldLozenge,
	...restConfig
}: FieldConfiguration): {
	[key: string]: unknown;
} => restConfig;

const normalizeConfiguration = (
	configuration?: FieldConfiguration,
):
	| {
			[key: string]: unknown;
	  }
	| undefined => {
	let config = configuration;
	if (config) {
		// Remove any inactive field lozenge data since it is localized message data that we shouldn't persist
		config = normalizeInactiveFieldLozenge(config);
		return Object.keys(config).length === 0 ? undefined : config;
	}
	return undefined;
};

const normalizeOptions = (options?: FieldOptions): FieldOptionsOnServer | undefined =>
	Array.isArray(options)
		? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			(options as FieldOptions)
				.map(({ optimisticId, ...rest }: FieldOption): FieldOptionOnServer => rest)
				.filter(removeEmptyOptions)
		: undefined;

const normalizeDefaultValue = (defaultValue?: unknown) =>
	Array.isArray(defaultValue)
		? defaultValue.map(({ optimisticId, ...rest }) => rest)
		: defaultValue;
/**
 * Copied from {@link src/packages/project-settings/issue-type-page/src/ops/save-changes/index.js#cleanUpdatedField}.
 */
export const cleanFieldForRequest = (field: AssociatedField): FieldRequestData => ({
	externalUuid: field.externalUuid,
	name: field.name,
	description: field.description,
	type: field.type,
	custom: field.custom,
	// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
	global: field.global !== undefined ? field.global : undefined,
	required: field.required,
	operations: field.operations,
	provider: field.provider,
	options: normalizeOptions(field.options),
	defaultValue: normalizeDefaultValue(field.defaultValue),
	properties: {
		[JSD_FIELD_ALIAS]: field.alternateName || null,
		[JSD_FIELD_HELPTEXT]: field.alternateDescription || null,
	},
	configuration: normalizeConfiguration(field.configuration),
});
